import { createSelector } from '@ngrx/store';
import { AppState } from '..';

export const selectAircraftPlanningState = (state: AppState) => state.aircraftPlanning;

export const selectAircraftPlanning$ = createSelector(selectAircraftPlanningState, (aircraftPlanning) => aircraftPlanning.data);

export const selectAircraftPlanningLoaded$ = createSelector(selectAircraftPlanningState, (aircraftPlanning) => aircraftPlanning.loaded);
